module.exports = __webpack_public_path__ + "static/media/escape.5785502d.webp";